// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomerInfo_container__3Du5W","details":"CustomerInfo_details__1uLPp","sections":"CustomerInfo_sections__16XK1"};